import { render } from "./tableList.vue?vue&type=template&id=ed5c11e0&scoped=true"
import script from "./tableList.vue?vue&type=script&lang=js"
export * from "./tableList.vue?vue&type=script&lang=js"

import "./tableList.vue?vue&type=style&index=0&id=ed5c11e0&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed5c11e0"]])

export default __exports__